import React, { Component } from 'react';
import { getAuthProviderLoginUrl } from '../utils/auth_url';
import Audit from '../utils/audit_util';

class LoginLoader extends Component {
    componentDidMount() {
        const authProviderUrl = getAuthProviderLoginUrl();
        Audit.LogUserAction('login.started', 'login', 'started');
        window.location.href = authProviderUrl;
    }
    
    render() { 
        return ( 
            <div>
                Redirecting...
            </div>
         );
    }
}

export default LoginLoader;
